__turbopack_context__.v({
  "container": "Slider-module__3P10xq__container",
  "container__swiper": "Slider-module__3P10xq__container__swiper",
  "container__swiper__slide": "Slider-module__3P10xq__container__swiper__slide",
  "container__swiper__slide__title": "Slider-module__3P10xq__container__swiper__slide__title",
  "swiper_buttons": "Slider-module__3P10xq__swiper_buttons",
  "swiper_buttons__prev": "Slider-module__3P10xq__swiper_buttons__prev",
});
